import type { UseQueryResult } from '@tanstack/react-query';
import { useRelatedOrgs } from '@/lib/relationships/use-related-orgs';

/** An agency a Super Admin may onboard a client under. */
export interface AssignableAgency {
  tenantId: string;
  displayName: string;
}

/**
 * Agencies the caller (SA) may onboard a client under.
 *
 * ENT-255: now sourced from `relatedOrgs(kinds:[MANAGES], direction:SOURCE,
 * persona:"AGENCY", q)` — the `assignableAgencies` preset is `@deprecated`
 * (removed after FE cut-over, ENT-263). Public shape (`AssignableAgency[]`) and
 * the `(q, enabled)` signature are unchanged, so `OnboardUnderField` needs no
 * edits. `enabled` is ANDed with the active-context check inside `useRelatedOrgs`.
 * `relatedOrgs.name` is always non-null (`|| tenantId` kept defensively).
 */
export function useAssignableAgencies(
  q: string | undefined,
  enabled: boolean,
): UseQueryResult<AssignableAgency[]> {
  return useRelatedOrgs(
    { kinds: ['MANAGES'], direction: 'SOURCE', persona: 'AGENCY', q, enabled },
    {
      select: (rows): AssignableAgency[] =>
        rows.map((o) => ({ tenantId: o.tenantId, displayName: o.name || o.tenantId })),
    },
  );
}
